import isNull from "./NullChecking";

const FormatPhoneNumber = (inputValue) => {
  // Remove non-numeric characters from input
  if (!isNull(inputValue)) {
    const numericValue = inputValue.replace(/\D/g, '');
    // Format the numeric value
    let formattedValue = '';

    if (numericValue.length > 0) {
      formattedValue = '(' + numericValue.substring(0, 3) + ') ';
    }
    if (numericValue.length >= 4) {
      formattedValue += numericValue.substring(3, 6) + '-';
    }
    if (numericValue.length >= 7) {
      formattedValue += numericValue.substring(6, 10);
    }
    return formattedValue;
  }else{
    return '';
  }
};
export default FormatPhoneNumber;